import { useQuery } from '@tanstack/react-query';
import { openapiAPI } from '../utils/api';
import type { OpenapiQuotaResponse } from '../types/openapi';

export const OPENAPI_QUOTA_QUERY_KEY = ['openapi', 'quota'] as const;

export function useOpenapiQuota(enabled: boolean = true) {
  return useQuery<OpenapiQuotaResponse>({
    queryKey: OPENAPI_QUOTA_QUERY_KEY,
    queryFn: async () => {
      const res = await openapiAPI.getQuota();
      return res.data;
    },
    enabled,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
    refetchInterval: 30_000,
  });
}
